export default __webpack_public_path__ + "static/media/three-image.177c9a05.png";